(function(){
  const all = (r,s)=>Array.from(r.querySelectorAll(s));

  function normalizeYouTube(u){
    let id = '';
    if (/youtu\.be$/i.test(u.hostname)) {
      id = u.pathname.split('/').filter(Boolean).pop() || '';
      u.hostname = 'www.youtube.com';
      u.pathname = `/embed/${id}`;
      u.search = '';
    } else {
      if (u.pathname.includes('/embed/')) {
        id = u.pathname.split('/').pop();
      } else {
        id = u.searchParams.get('v') || u.pathname.split('/').pop();
        u.pathname = `/embed/${id}`;
      }
      u.hostname = 'www.youtube.com';
    }
    u.searchParams.set('autoplay','1');
    u.searchParams.set('mute','1');
    u.searchParams.set('playsinline','1');
    u.searchParams.set('controls','0');
    u.searchParams.set('rel','0');
    u.searchParams.set('modestbranding','1');
    if (id) u.searchParams.set('playlist', id);
    return u;
  }

  function normalizeVimeo(u){
    const m = (u.pathname.match(/(\d+)/) || [])[1];
    u.hostname = 'player.vimeo.com';
    u.pathname = `/video/${m || ''}`;
    u.searchParams.set('background','1');
    u.searchParams.set('muted','1');
    u.searchParams.set('playsinline','1');
    u.searchParams.set('autoplay','1');
    u.searchParams.set('loop','1');
    return u;
  }

  function tuneIframe(iframe){
    try{
      const u = new URL(iframe.getAttribute('src'), location.href);
      if (/youtube\.com$/i.test(u.hostname) || /youtu\.be$/i.test(u.hostname)) {
        iframe.src = normalizeYouTube(u).toString();
      } else if (/vimeo\.com$/i.test(u.hostname) || /player\.vimeo\.com$/i.test(u.hostname)) {
        iframe.src = normalizeVimeo(u).toString();
      }
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
    }catch(e){}
  }

  function fit16x9(el, container){
    const cw = container.clientWidth, ch = container.clientHeight;
    if(!cw || !ch) return;
    const ratio = 16/9;
    let w = cw, h = cw/ratio;
    if (h < ch){ h = ch; w = h*ratio; }
    Object.assign(el.style, {
      position:'absolute', top:'50%', left:'50%',
      width: w+'px', height: h+'px',
      transform:'translate(-50%,-50%)'
    });
  }

  function initSection(sec){
    const reduce = sec.dataset.reduceMotion==='true' ||
                   matchMedia('(prefers-reduced-motion: reduce)').matches;

    // VIDEO (MP4 / Shopify hosted)
    const videos = all(sec,'.beez-video-bg__video, video');
    videos.forEach(v=>{
      try{
        // attributi PRIMA del play (iOS)
        v.setAttribute('muted',''); v.muted = true;
        v.setAttribute('playsinline',''); v.playsInline = true;
        v.setAttribute('webkit-playsinline','');
        v.setAttribute('autoplay',''); v.autoplay = true;
        v.setAttribute('loop',''); v.loop = true;
        v.preload = 'auto';
        v.style.objectFit = 'cover';

        const tryPlay = ()=>{ const p=v.play(); if(p&&p.catch){ p.catch(()=>{});} };
        if(!reduce){
          if (v.readyState >= 2) tryPlay();
          else v.addEventListener('canplay', tryPlay, { once:true });
        }
      }catch(_){}
    });

    // IFRAME (YT/Vimeo) + FIT
    const bg = sec.querySelector('.beez-video-bg');
    if (bg){
      const iframe = bg.querySelector('.beez-video-bg__iframe');
      if(iframe){
        if(!reduce) tuneIframe(iframe);
        const doFit = ()=>fit16x9(iframe, bg);
        doFit(); new ResizeObserver(doFit).observe(bg);
        addEventListener('orientationchange', doFit, {passive:true});
      }
    }

    // MOBILE/AUTOPLAY KICK (iOS)
    const kick = ()=>{
      videos.forEach(v=>{ if (v.paused) { try { v.play(); } catch(_){} } });
      const ifr = sec.querySelector('.beez-video-bg__iframe');
      if (ifr && !reduce) tuneIframe(ifr); // ri-normalizza per forzare restart
      window.removeEventListener('touchstart', kick);
      window.removeEventListener('pointerdown', kick);
    };
    window.addEventListener('touchstart', kick, { once:true, passive:true });
    window.addEventListener('pointerdown', kick, { once:true });

    // al ritorno in foreground, riprova
    document.addEventListener('visibilitychange', ()=>{
      if (!document.hidden) kick();
    }, { passive:true });
  }

  function boot(root=document){ all(root,'.beezfy-theme-hero').forEach(initSection); }
  document.addEventListener('DOMContentLoaded', ()=>boot());
  document.addEventListener('shopify:section:load', e=>boot(e.target));
  document.addEventListener('shopify:section:unload', e=>{
    all(e.target,'video').forEach(v=>{ try{ v.pause(); }catch(_){ }});
  });
})();